export const CLINIC_GET_REQUESTED = 'CLINIC_GET_REQUESTED';
export const CLINIC_GET_SUCCEED = 'CLINIC_GET_SUCCEED';
export const CLINIC_GET_FAILED = 'CLINIC_GET_FAILED';
